/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  
  document.addEventListener('theme:scroll', function () {
    var cartBar = document.querySelector('.cart-bar');
    var footer = document.querySelector('.footer-sections');
    if (!cartBar || !footer) return;

    var footerTop = footer.getBoundingClientRect().top;
    var windowHeight = window.innerHeight;
    var isFooterVisible = footerTop <= windowHeight;

    cartBar.classList.toggle('cart-bar--hide-footer', isFooterVisible);
  });


})();
